import { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Fetch a site_content block (fallback to empty object if missing or errored).
 * Usage: const about = useSiteContent('about_page', { /* defaults *\/ });
 */
export function useSiteContent(contentId, defaults = {}) {
  const [data, setData] = useState(defaults);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    axios.get(`${BACKEND_URL}/api/public/site-content/${contentId}`)
      .then((res) => {
        if (mounted) {
          setData({ ...defaults, ...(res.data?.data || {}) });
        }
      })
      .catch(() => { if (mounted) setData(defaults); })
      .finally(() => { if (mounted) setLoading(false); });
    return () => { mounted = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contentId]);

  return { data, loading };
}

/**
 * Shortcut hook for the global image-display config
 * Returns { hide_empty_galleries, hide_empty_country_images, hide_empty_event_images, hide_empty_product_images, hide_empty_update_images }.
 * Defaults all to TRUE — cleanest public UI by default.
 */
export function useImageDisplayConfig() {
  const { data } = useSiteContent('image_display_config', {
    hide_empty_galleries: true,
    hide_empty_country_images: true,
    hide_empty_event_images: true,
    hide_empty_product_images: true,
    hide_empty_update_images: true,
  });
  return data;
}
